import { CardCvcElement } from '@stripe/react-stripe-js';
import createInput from './utils.js';

const CardCVCInput = createInput(CardCvcElement);

export { CardCVCInput };
